
$(document).ready(function(){
    /// Main search input
    $('#pageheader .search-box input[type="text"]').bind('focusin focusout', function(e){
        $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
    });
     

    /// Live search
    var preLoadLoadGif = $('<img src="//ecrotek.com.au/cdn/shop/t/56/assets/ajax-load.gif?v=27241" />');
    var searchTimeoutThrottle = 500;
    var searchTimeoutID = -1;
    var currReqObj = null;
    var $resultsBox = $('<div class="results-box flxdis" />').appendTo('.results-box--wrapper');
    $('#pageheader .search-box input[type="text"]').bind('keyup change', function(){
        //Only search if search string longer than 2, and it has changed
	if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
            //Reset previous value
            $(this).data('oldval', $(this).val());
            
            // Kill outstanding ajax request
            if(currReqObj != null) currReqObj.abort();
            
            // Kill previous search
            clearTimeout(searchTimeoutID);
          
          	var $form = $(this).closest('form');
          
          	//Search term
          	var term = '*' + $form.find('input[name="q"]').val() + '*';
            
            //URL for full search page
            var linkURL = $form.attr('action') + '?type=article&q=' + term;
            
            //Show loading
            $resultsBox.html('<div class="load"></div>');
            
            // Do next search (in X milliseconds)
            searchTimeoutID = setTimeout(function(){
                //Ajax hit on search page
                currReqObj = $.ajax({
                  url: '/search',
                  data: {
                    type: 'article',
                    view: 'json',
                    q: term,
                  },
                  dataType: "json",
                  success: function(data){
                        currReqObj = null;
                        console.log({resultCount: data.results_total})
                        if(data.results_total == 0) {
                            //No results
                            // $resultsBox.html('<div class="note">'+ "Translation missing: en.layout.live_search.no_results" +'</div>');
                            $('.native-featured-article').hide();
                            $('.loadingcircle').hide();
                            $('.showifnocontent').show();                        
                          } else {
                            //Numerous results
                            $resultsBox.empty();
                              $.each(data.results, function(index, item){
                                var xshow = 'wholesale'; //term for products we dont want to show
                                if(!(item.title.toLowerCase().indexOf(xshow) > -1)) {
                                  var $row = $('<div class="featured-article blog-card one-half columns article card show-border-false medium-down--one-half small-down--one-whole has-margin-bottom" data-tags="All, " data-title="'+item.title+'"></div>');
                                  $row.append('<div class="card-image blog-card__image"><figure class="image"> <a href="'+item.url+'" title="'+item.title+'"><div class="image-element__wrap" style=" "> <img alt="'+item.title+'" class="transition--fade-in lazyautosizes ls-is-cached lazyloaded" data-src="' + item.thumbnail + '" data-sizes="auto" data-aspectratio="5000/3333" height="3333" width="5000" style=";" sizes="491px" src="' + item.thumbnail + '"></div></a></figure></div> <div class="card-content blog-card__content"> <div> <div class="article-tags"></div> <div class="media"> <div class="media-content"> <h4 class="title"> <a class="featured-article--link" href="'+item.url+'">'+item.title+'</a></h4></div></div> <div class="excerpt has-margin-bottom">'+item.text_content+'</div></div><div class="blog-card__read-more buttons"> <a href="'+item.url+'" class="button button--1 " data-date="">Read more</a></div></div>');
                                  $resultsBox.append($row);
                                }
                              });
                              $('.showifnocontent').hide(); 
                            $('.native-featured-article').show();
                            $('.loadingcircle').show();
                        }
                  }
                });
            }, searchTimeoutThrottle);
        } else if ($(this).val().length <= 2) {
            //Deleted text? Clear results
            $resultsBox.empty();
        }
    }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
        //Focus, show results
        $resultsBox.fadeIn(200);
    }).bind('click', function(e){
        //Click, prevent body from receiving click event
        e.stopPropagation();
    });
    //Search box should mimic live search string: products only, partial match
    $('.search-form, #search-form').on('submit', function(e){
      e.preventDefault();
      var term = '*' + $(this).find('input[name="q"]').val() + '*';
      var linkURL = $(this).attr('action') + '?type=article&q=' + term;
      window.location = linkURL;
    });

    //Search box should mimic live search string: products only, partial match
    $('form.search-form input').keypress(function (e) {
      // if ($('form.search-form input').val().length === 0) {
      //   // $('.wrapMe.lazy-card').show();
      //   // $('.loadingcircle').show();
      //   // $('.showifnocontent').hide();
      //   alert('TEST');
      // }
      if(e.which == 13) {
        e.preventDefault();
        $('#search-articles .search-form button').trigger('click');
      }
    });

    $('form.search-form input').blur(function(){
      if( $(this).val().length === 0 ) {
        $('.native-featured-article').show();
        $('.loadingcircle').show();
      } else {
        $('.native-featured-article').hide();
        $('.loadingcircle').hide();     
      }
    });

    // search ends
});